import {
	FunctionComponent,
	ReactElement,
	ReactNode,
	useState,
	createContext,
	useEffect,
} from 'react';
import {
	ToastPosition,
	ToastMessage as IToastMessage,
} from '@/components/ui/toast-message-container/types';

export interface IToastMessageContext {
	open?: boolean;
	message?: IToastMessage;
	position?: ToastPosition;
	onClose: () => void;
	setPosition: (position: ToastPosition) => void;
	dispatch: (message: IToastMessage) => void;
	remove: () => void;
}

export const ToastMessageContext = createContext<IToastMessageContext>({
	onClose: () => {},
	setPosition: () => {},
	dispatch: () => {},
	remove: () => {},
});

export const ToastMessageProvider: FunctionComponent<{ children: ReactNode }> = ({
	children,
}): ReactElement => {
	const [open, setOpen] = useState(false);
	const [position, setPosition] = useState<ToastPosition>({
		vertical: 'bottom',
		horizontal: 'right',
	});
	const [message, setMessage] = useState<IToastMessage>();

	useEffect(() => message && setOpen(true), [message]);

	const onClose = () => setOpen(false);
	const remove = () => setMessage(undefined);
	const dispatch = (message: IToastMessage) => {
		setMessage(message);
	};

	return (
		<ToastMessageContext.Provider
			value={{ open, onClose, message, position, setPosition, dispatch, remove }}
		>
			{children}
		</ToastMessageContext.Provider>
	);
};
